import { ISingleCustomPage } from 'interfaces/navigationPage.interface'

import { BotulismSlugs } from './BotulismMenu'
import BotulismTabs from 'modules/Botulism'

const BotulismDashboard: ISingleCustomPage<BotulismSlugs> = {
  path: [''],
  component: BotulismTabs,
}

export const BotulismCustomPages: Record<
  string,
  ISingleCustomPage<BotulismSlugs>
> = {
  BotulismDashboard,
}
